<template>
    <b-card no-body :header="$t('prod_kaasmerkgeg', { ns: 'production' })">
        <div>
            <div class="form-inline">
                <b-button
                    :aria-expanded="gebruikKaasmerk ? 'true' : 'false'"
                    aria-controls="collapseMerk"
                    @click="gebruikKaasmerk = !gebruikKaasmerk"
                    :disabled="!editAllowed"
                    >{{ $t('prod_usemarks', { ns: 'production' }) }}</b-button
                >&nbsp;
                <b-form-checkbox
                    id="cbSubseries"
                    v-model="showSubseries"
                    @change="setChangedSubSeries()"
                    :disabled="!editAllowed"
                >
                    {{ $t('prod_subseries', { ns: 'production' }) }}
                </b-form-checkbox>
            </div>
            <b-collapse
                id="collapseMerk"
                v-model="gebruikKaasmerk"
                class="mt-2"
            >
                <b-card>
                    <b-row v-if="showSubseries">
                        <div
                            class="form-inline"
                            v-for="(ucm, index) in ucmList"
                            v-bind:key="index"
                        >
                            <b-col sm="12" class="mx-0 px-0 my-1 py-0">
                                <merken-combo
                                    v-bind:key="index"
                                    v-model="ucmList[index]"
                                    v-bind:editAllowed="editAllowed"
                                    v-bind:cheeseProductID="ucm.productID"
                                    @change="setChanged"
                                    @delete="verwijderItem"
                                    @copy="copyItem"
                                    @input="check_doubles"
                                    @validComponent="setMarksValid"
                                />
                            </b-col>
                        </div>
                    </b-row>

                    <b-row v-else>
                        <b-col sm="12">
                            <b-row>
                                <merken-combo
                                    v-if="currentItem != undefined"
                                    v-model="currentItem"
                                    :editAllowed="editAllowed"
                                    :cheeseProductID="localProductID"
                                    :showSubseries="showSubseries"
                                    @change="setChanged"
                                    @input="set_inputKaasmerk"
                                    @validComponent="setMarksValid"
                                />
                            </b-row>
                        </b-col>
                        <b-alert
                            v-model="showDismissibleAlert"
                            variant="danger"
                            dismissible
                        >
                            {{ alertText }}
                        </b-alert>
                    </b-row>
                </b-card>
            </b-collapse>
            <b-alert v-model="showNoStockAlert" variant="danger" dismissible>
                {{ alertNoStock }}
            </b-alert>
            <b-card>
                <b-row>
                    <b-col sm="10" class="mx-0 px-0 my-1 py-0">
                        <b-row class="mx-0 px-0 my-1 py-0">
                            <b-col sm="3" class="mx-0 px-0 my-1 py-0">
                                <label
                                    >{{
                                        $t('prod_xprogramma', {
                                            ns: 'production',
                                            val: $t('prod_pers', {
                                                ns: 'production'
                                            })
                                        })
                                    }}:
                                </label>
                            </b-col>
                            <b-col
                                sm="9"
                                class="form-inline mx-0 px-0 my-1 py-0"
                            >
                                <b-form-input
                                    id="input-program"
                                    :placeholder="
                                        $t('prod_xprogramma', {
                                            ns: 'production',
                                            val: $t('prod_pers', {
                                                ns: 'production'
                                            })
                                        })
                                    "
                                    v-model="programma"
                                    @change="set_inputProgramma"
                                    :disabled="!editAllowed"
                                ></b-form-input>
                                <b-form-select
                                    v-model="localApparaat"
                                    :options="apparatenList"
                                    :disabled="
                                        !editAllowed || disableSelEquipment
                                    "
                                >
                                    <template #first>
                                        <b-form-select-option value=""
                                            >--
                                            {{
                                                $t('com_selecteer', {
                                                    ns: 'common'
                                                })
                                            }}
                                            --</b-form-select-option
                                        >
                                    </template>
                                </b-form-select>
                                <b-button
                                    v-if="editAllowed"
                                    @click="newStep()"
                                    class="bgc_aux_normal"
                                    :disabled="localApparaat == -1"
                                    ><font-awesome-icon
                                        icon="arrow-down"
                                        size="1x"
                                    />
                                </b-button>
                                <b-button
                                    v-if="editAllowed && stepLijst.length == 0"
                                    v-b-tooltip.hover
                                    :title="buttonTooltip"
                                    @click="likePrevious()"
                                    class="bgc_aux_unknown"
                                    :disabled="localApparaat == -1"
                                    ><font-awesome-icon
                                        icon="arrow-down"
                                        size="1x"
                                    />
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="2" class="mx-0 px-0 my-1 py-0">
                        <b-button
                            id="myDefault"
                            @click="SetDefaults()"
                            :disabled="!editAllowed"
                            class="bgc_aux_warning float-right"
                            ><font-awesome-icon icon="edit" size="1x" />&nbsp;{{
                                $t('com_default', { ns: 'common' })
                            }}
                        </b-button>
                    </b-col>
                </b-row>

                <div>
                    <div
                        class="form-inline"
                        v-for="(equipmentstep, index) in stepLijst"
                        v-bind:key="index"
                    >
                        <b-col sm="11" class="mx-0 px-0 my-1 py-0">
                            <equipment-step-combo
                                :key="index"
                                v-model="stepLijst[index]"
                                :editAllowed="editAllowed"
                                :baseDateTime="theBakDrain.boekDatum"
                                :baseUnit="baseUnitEquipment"
                                :recept="programma"
                                @change="set_input"
                                @input="check_doublestepnumber"
                                @validComponent="setMarksValid"
                            />
                        </b-col>
                        <b-col sm="1" class="mx-0 px-0 my-1 py-0">
                            <b-button
                                v-if="editAllowed"
                                @click="verwijderStep(equipmentstep)"
                                class="bgc_aux_alarm"
                                ><font-awesome-icon
                                    icon="trash-alt"
                                    size="1x"
                                />
                            </b-button>
                        </b-col>
                    </div>
                </div>
            </b-card>
        </div>
    </b-card>
</template>

<script>
import { MerkenCombo, EquipmentStepCombo } from '../components';
import { BakDrain } from '@/models/BakInfo_helper';
import { loadList, loadItem } from '@/models/DataHelper';
import { Feature } from '@/models/Features';
import DateHelper from '@/models/DateHelper';
import { CheeseMarks, EquipmentStepInfo } from '@/models/BakInfo';

export default {
    name: 'CardMerkPers',
    data() {
        return {
            overpomptijdstip: null,
            programma: null,
            gebruikKaasmerk: true,
            kaasmerk: null,
            aantalKazen: 0,
            aantalKazenBasis: 0,
            stepid: -1,
            eindNummerBasis: null,
            currentItem: null,
            localApparaat: -1,
            baseUnitEquipment: window.constants.BAR,
            apparatenList: [],
            markstockList: [],
            validMark: true,
            validMarks: true,
            disableSelEquipment: false,
            showDismissibleAlert: false,
            showNoStockAlert: false,
            showSubseries: false,
            buttonTooltip: this.$t('prod_previoussteps', { ns: 'production' }),
            alertText: '',
            reminder: '',
            aangeraakt: 1,
            alertNoStock: this.$t('prod_nostock', {
                ns: 'production',
                val: this.$t('com_marks', {
                    ns: 'common'
                })
            }),
            messageLetterBeideMerken: this.$t('prod_beideletters', {
                ns: 'production'
            }),
            messageLetterEindMerk: this.$t('prod_eindletter', {
                ns: 'production'
            }),
            messageNummerVerplicht: this.$t('prod_nummerverplicht', {
                ns: 'production'
            }),
            messageStartKleinerDanEind: this.$t('prod_startkleinereind', {
                ns: 'production'
            }),
            messageVoorstel: this.$t('prod_marksuggestion', {
                ns: 'production'
            }),
            messageUniek: this.$t('prod_warnuniekinlijst2', {
                ns: 'production'
            }),
            messageMaxSeries: this.$t('prod_max2series', { ns: 'production' })
        };
    },
    components: { MerkenCombo, EquipmentStepCombo },
    model: {
        prop: 'theBakDrain',
        event: 'changedRecipe'
    },
    props: {
        theBakDrain: {
            type: BakDrain,
            default: null
        },
        editAllowed: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ucmList() {
            // eslint-disable-next-line no-unused-vars
            const tel = this.aangeraakt;
            return this.theBakDrain.bakKaasMerk.subSeries.filter(
                (x) =>
                    x.isDeleted == false &&
                    (x.nouse == undefined || x.nouse == false)
            );
        },
        flexList() {
            return this.markstockList.map((x) => ({
                value: x.id,
                text:
                    x.letters +
                    ' (' +
                    x.startnummer +
                    ' - ' +
                    x.eindnummer +
                    ' )',
                stockItemId: x.id,
                letter: x.letters,
                start: x.startnummer,
                eind: x.eindnummer
            }));
        },
        localProductID() {
            return this.kaasmerk ? this.kaasmerk.productID : -1;
        },
        stepLijst() {
            // eslint-disable-next-line no-unused-vars
            const tel = this.aangeraakt;
            return this.theBakDrain.bakPersStappenLijst.filter(
                (x) => x.nouse == undefined || x.nouse == false
            );
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        setMarksValid(valid) {
            this.validMarks = valid;
            this.validMark = valid;
        },
        async verwijderItem(subserie) {
            const item = this.theBakDrain.bakKaasMerk.subSeries.find((x) => {
                return (
                    x.bakId === subserie.bakId &&
                    x.vormID === subserie.vormID &&
                    x.productID === subserie.productID &&
                    x.nouse == undefined
                );
            });
            if (item) {
                if (item.isNew) {
                    const index =
                        this.theBakDrain.bakKaasMerk.subSeries.findIndex(
                            (x) => {
                                return (
                                    x.bakId === subserie.bakId &&
                                    x.vormID === subserie.vormID &&
                                    x.productID === subserie.productID &&
                                    x.nouse == undefined
                                );
                            }
                        );
                    if (index > -1) {
                        this.theBakDrain.bakKaasMerk.subSeries.splice(index, 1);
                        this.aangeraakt += 1;
                        this.showDismissibleAlert = false;
                    }
                } else {
                    const doClose = await this.$root.showConfirmationBox(
                        this.$t('com_delete', {
                            ns: 'common',
                            val: this.$t('prod_subserie', {
                                ns: 'production'
                            })
                        }) +
                            subserie.bakId +
                            ':' +
                            subserie.vormID
                    );
                    if (doClose) {
                        item.isDeleted = true;
                        this.aangeraakt += 1;
                        this.setChanged();
                    }
                }
                this.check_doubles();
            }
        },
        check_doubles() {
            this.$nextTick(() => {
                const x = _(this.theBakDrain.bakKaasMerk.subSeries.slice(0))
                    .groupBy((x) => `"${x.vormID}+${x.productID}"`)
                    .map((value, key) => ({
                        categorie: key,
                        subserie: value
                    }))
                    .value();
                const y = x.filter((o) => o.subserie.length > 1);
                this.validMarks = !(y.length > 0);
                if (y.length > 0) {
                    this.showAlert(this.messageUniek);
                } else {
                    this.check_maxStockItemNumber();
                }
            });
        },
        check_maxStockItemNumber() {
            // maximaal 2 merkvoorraaditems in het spel zijn. 3 is errorer mogen
            const a = this.theBakDrain.bakKaasMerk.subSeries.slice(0);
            const arrStockIds = a.map((x) => x.beginStockItemID);
            const b = a.map((x) => x.eindStockItemID);
            arrStockIds.push(...b);
            arrStockIds.push(this.theBakDrain.bakKaasMerk.beginStockItemID);
            arrStockIds.push(this.theBakDrain.bakKaasMerk.eindStockItemID);
            const unique = arrStockIds.filter(
                (value, index, array) => array.indexOf(value) === index
            );
            if (unique.length > 2) {
                this.showAlert(this.messageMaxSeries);
                return false;
            }
            return true;
        },
        copyItem(merkitem) {
            const nieuw = new CheeseMarks({
                batchID: merkitem.bakId,
                productID: merkitem.productID,
                merkProductID: merkitem.merkProductID,
                markTypeID: merkitem.markTypeID
            });
            nieuw.kazen = 0;
            nieuw.vormID = merkitem.vormID;
            nieuw.beginStockItemID = merkitem.beginStockItemID;
            nieuw.eindStockItemID = merkitem.eindStockItemID;
            nieuw.startLetter = merkitem.startLetter;
            nieuw.eindLetter = merkitem.eindLetter;
            this.theBakDrain.bakKaasMerk.subSeries.push(nieuw);
            this.aangeraakt += 1;
            this.setChanged();
        },
        set_inputProgramma() {
            this.theBakDrain.Persprogram = this.programma;
            this.setChanged();
        },
        set_inputKaasmerk(val) {
            this.kaasmerk = val;
            this.kaasmerk.isChanged = true;
            this.theBakDrain.bakKaasMerk = this.kaasmerk;
            this.setChanged();
        },
        setChanged() {
            this.$emit('validComponent', this.validMark);
            this.$emit('saveSubseries', this.showSubseries);
            this.$emit('change', true);
        },
        setChangedSubSeries() {
            if (this.showSubseries) {
                if (this.kaasmerk.subSeries.length < 1) {
                    // subserie aanmaken
                    const nieuw = new CheeseMarks({
                        batchID: this.kaasmerk.bakId,
                        productID: this.kaasmerk.productID,
                        merkProductID: this.kaasmerk.merkProductID,
                        markTypeID: this.kaasmerk.merktypeID
                    });
                    nieuw.kazen = this.kaasmerk.kazen;
                    nieuw.vormID = this.kaasmerk.vormID;
                    nieuw.beginStockItemID = this.kaasmerk.beginStockItemID;
                    nieuw.eindStockItemID = this.kaasmerk.eindStockItemID;
                    nieuw.startLetter = this.kaasmerk.startLetter;
                    nieuw.eindLetter = this.kaasmerk.eindLetter;
                    nieuw.startNummer = this.kaasmerk.startNummer;
                    nieuw.eindNummer = this.kaasmerk.eindNummer;
                    nieuw.suggestion = this.kaasmerk.suggestion;
                    this.kaasmerk.subSeries.push(nieuw);
                    this.theBakDrain.bakKaasMerk = this.kaasmerk;
                    this.aangeraakt += 1;
                }
            } else {
                this.currentItem = this.kaasmerk;
            }
            this.setChanged();
        },
        async SetDefaults() {
            const selectionData = { recipeid: this.theBakDrain.receptID };
            const recipe = await loadList(
                'recipe/getRecipe',
                'recipe/loadRecipeComplete',
                selectionData,
                true,
                this.$t
            );
            this.programma = recipe.recProduction.progPers;
        },
        async loadKaasMerkVoorstel(km) {
            if (km.merkProductID != undefined) {
                const marktype = await loadItem(
                    'production/loadMarkType',
                    { productID: km.merkProductID },
                    this.$t
                );
                let merkFilled = false;
                if (marktype.data.lastUsedLetter != undefined) {
                    const objTest = this.flexList.find(
                        (x) =>
                            x.letter == marktype.data.lastUsedLetter &&
                            x.start <= marktype.data.lastUsedNumber &&
                            x.eind > marktype.data.lastUsedNumber
                    );
                    if (objTest) {
                        km.startLetter = marktype.data.lastUsedLetter;
                        km.eindLetter = marktype.data.lastUsedLetter;
                        km.startNummer = marktype.data.lastUsedNumber + 1;
                        merkFilled = true;
                    }
                }
                if (!merkFilled) {
                    // nieuw merkenserie
                    if (this.flexList.length > 0) {
                        km.startLetter = this.flexList[0].letter;
                        km.eindLetter = this.flexList[0].letter;
                        km.startNummer = this.flexList[0].start;
                    }
                }
                km.eindNummer = km.startNummer + km.kazen - 1;
                const obj = this.flexList.find(
                    (x) =>
                        x.letter == km.startLetter &&
                        x.start <= km.startNummer &&
                        x.eind > km.startNummer
                );
                if (obj) {
                    // we hebben een startserie
                    this.kaasmerk.beginStockItemID = obj.stockItemId;
                    this.kaasmerk.eindStockItemID = obj.stockItemId;
                    // als ze starten met een serie dan is lastUsedNumber hier null
                    if (km.startNummer == undefined && obj != undefined) {
                        // waarschijnlijk start nieuwe serie dus is startnummer nummer 1 van die serie
                        km.startNummer = obj.start;
                    }
                    km.eindNummer = km.startNummer + km.kazen - 1;
                } else {
                    const obj1 = this.flexList.find(
                        (x) =>
                            x.letters == km.eindLetter &&
                            x.start < km.eindNummer &&
                            x.eind >= km.eindNummer
                    );
                    const stockID1 = obj1 ? obj1.stockItemId : null;
                    this.kaasmerk.eindStockItemID = stockID1;
                }
                // nieuw: vul ook het voorstel voor de subseries, zijn gesorteerd op belangrijkheid (aantal)
                let start = km.startNummer;
                const lijst = km.subSeries.filter(
                    (x) =>
                        x.isDeleted == false &&
                        (x.nouse == undefined || x.nouse == false)
                );
                for (let i = 0; i < lijst.length; i++) {
                    lijst[i].beginStockItemID = this.kaasmerk.beginStockItemID;
                    lijst[i].eindStockItemID = this.kaasmerk.eindStockItemID; // klopt meestal
                    lijst[i].startLetter = km.startLetter;
                    lijst[i].eindLetter = km.startLetter;
                    lijst[i].startNummer = start;
                    lijst[i].eindNummer =
                        lijst[i].startNummer + lijst[i].kazen - 1;
                    start = lijst[i].startNummer + lijst[i].kazen;
                }
                this.aangeraakt += 1;
            } else {
                if (this.flexList.length > 0) {
                    this.kaasmerk.startStockItemID =
                        this.flexList[0].stockItemId;
                    this.kaasmerk.eindStockItemID =
                        this.flexList[0].stockItemId;
                    km.startNummer = this.flexList[0].start;
                    km.eindNummer = km.startNummer + km.kazen - 1;
                }
            }
            this.kaasmerk = km;
            if (this.eindNummerBasis == undefined)
                this.eindNummerBasis = this.kaasmerk.eindNummer;
            this.setChanged();
            return km;
        },
        async verwijderStep(equipmentstep) {
            const item = this.theBakDrain.bakPersStappenLijst.find((x) => {
                return (
                    x.bakId === equipmentstep.bakId &&
                    x.stapNummer === equipmentstep.stapNummer &&
                    x.nouse == undefined
                );
            });
            if (item) {
                if (item.stepID < 0) {
                    const index =
                        this.theBakDrain.bakPersStappenLijst.findIndex((x) => {
                            return (
                                x.bakId === equipmentstep.bakId &&
                                x.stapNummer === equipmentstep.stapNummer &&
                                x.nouse == undefined
                            );
                        });
                    if (index > -1) {
                        this.theBakDrain.bakPersStappenLijst.splice(index, 1);
                        this.aangeraakt += 1;
                        this.showDismissibleAlert = false;
                    }
                } else {
                    const doClose = await this.$root.showConfirmationBox(
                        this.$t('com_delete', {
                            ns: 'common',
                            val: this.$t('prod_equipstep', { ns: 'production' })
                        }) +
                            ':' +
                            equipmentstep.stapNummer
                    );
                    if (doClose) {
                        item.nouse = true;
                        item.isDeleted = true;
                        this.aangeraakt += 1;
                        this.set_input();
                    }
                }
            }
        },
        newStep() {
            const nieuw = new EquipmentStepInfo();
            // haal de laatste stap op
            const lijst = this.theBakDrain.bakPersStappenLijst;
            const lastStep = lijst.length > 0 ? lijst[lijst.length - 1] : null;
            let datediff = null;
            if (lastStep) {
                const prevTime = lastStep.tijd;
                datediff = DateHelper.dateDiff(prevTime, new Date());
            }
            nieuw.bakID = this.theBakDrain.bakId;
            nieuw.apparaatID = this.localApparaat;
            nieuw.receptID = Number(this.programma);
            this.stepid -= 1;
            nieuw.stepID = this.stepid;
            nieuw.tijd = new Date();
            nieuw.registratieTijd = DateHelper.convertedToTime();
            nieuw.tijdsduur = DateHelper.TimeToMS(datediff);
            nieuw.temperatuur = lastStep?.temperatuur || null;
            nieuw.stapNummer = lijst.length + 1;
            this.theBakDrain.bakPersStappenLijst.push(nieuw);
            this.aangeraakt += 1;
            this.set_input();
        },
        async likePrevious() {
            const stepsinfo = await loadItem(
                'production/loadPreviousEquipmentSteps',
                { batchId: this.theBakDrain.bakId },
                this.$t
            );
            // als stepsinfo en stepsinfo.steps.length > 0 dan de stappen toevoegen aan de lijst met aangepaste registratieTijd (ebaseerd op now en per step de tijdsduur van de vorige stap)
            if (stepsinfo && stepsinfo.length > 0) {
                const now = new Date();
                let prevTime = DateHelper.MakeDateTime(now);
                for (let i = 0; i < stepsinfo.length; i++) {
                    const step = stepsinfo[i];
                    step.bakID = this.theBakDrain.bakId;
                    step.apparaatID = this.localApparaat;
                    step.receptID = this.programma ? Number(this.programma) : step.receptID;
                    this.stepid -= 1;
                    step.stepID = this.stepid;
                    // bereken de registratieTijd op basis van prevTime en de tijdsduur van de vorige stap
                    if (i > 0) {
                        const prevStep = stepsinfo[i - 1];
                        prevTime = DateHelper.addDifftoDate(prevTime, step.tijdsduur);
                        step.tijd = prevTime.toJSDate();
                        step.registratieTijd = DateHelper.convertedToTime(step.tijd);
                    } else {
                        step.registratieTijd = DateHelper.convertedToTime();
                        step.tijd = now;
                    }
                    this.theBakDrain.bakPersStappenLijst.push(step);
                }
                this.aangeraakt += 1;
                this.set_input();
            } else {
                this.buttonTooltip = this.$t('prod_noprevioussteps', { ns: 'production' });
            }
        },
        newDiffTime() {
            let prevTime = null;
            for (let i = 0; i < this.stepLijst.length; i++) {
                const nieuw = this.stepLijst[i];
                if (prevTime != undefined) {
                    const span = DateHelper.dateDiff(prevTime, nieuw.tijd);
                    nieuw.tijdsduur = DateHelper.TimeToMS(span);
                }
                prevTime = nieuw.tijd;
            }
        },
        check_doublestepnumber() {
            this.$nextTick(() => {
                const x = _(this.theBakDrain.bakPersStappenLijst.slice(0))
                    .groupBy((x) => `"${x.stapNummer}"`)
                    .map((value, key) => ({
                        categorie: key,
                        step: value
                    }))
                    .value();
                const y = x.filter((o) => o.step.length > 1);
                this.validMarks = !(y.length > 0);
                if (y.length > 0) {
                    this.showAlert(this.messageUniek);
                }
                this.newDiffTime();
            });
        },
        set_input() {
            this.$emit('validComponent', true);
            this.$emit('change', true);
        },
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        }
    },
    mounted() {},
    async created() {
        const steplijst = this.theBakDrain.bakPersStappenLijst;
        let eqID = -1;
        if (steplijst.length > 0) {
            eqID = steplijst[0].apparaatID;
        }
        const lijst = await loadList(
            'masterdata/getEquipmentLijst',
            'masterdata/loadEquipments',
            null,
            true,
            this.$t
        );
        this.apparatenList = lijst.filter((x) => x.object.typeID == 2); // 2=pers todo const
        if (this.apparatenList.length > 0) {
            if (eqID > -1) {
                const obj = this.apparatenList.find((x) => x.id == eqID);
                if (obj == undefined) {
                    const obj2 = await loadItem(
                        'masterdata/loadEquipment',
                        { equipmentid: eqID },
                        this.$t
                    );
                    if (obj2 == undefined) {
                        console.log(
                            'Apparaat in gebruik in pers stappen maar niet gevonden: ' +
                                eqID
                        );
                    } else {
                        const nobj = {
                            value: obj2.id,
                            text: obj2.naam,
                            id: obj2.id,
                            object: obj2
                        };
                        this.apparatenList.push(nobj);
                        this.disableSelEquipment = true;
                    }
                }
            }
            this.localApparaat = eqID != -1 ? eqID : this.apparatenList[0].id;
        }
        // haal de merkenseries op die op voorraad zijn voor deze kaassoort
        const locLijst = await loadList(
            'components/getCheesesComboLijst',
            'components/loadCheesesComboLijst',
            null,
            false,
            this.$t
        );
        if (this.theBakDrain.bakKaasMerk.merkProductID != undefined) {
            this.markstockList = await loadList(
                'stock/getMarkStockItemLijst',
                'stock/loadMarkStockByProduct',
                { productid: this.theBakDrain.bakKaasMerk.merkProductID },
                true,
                this.$t
            );
            this.showNoStockAlert = this.markstockList.length < 1;
        }
        // klopt dit??
        this.gebruikKaasmerk = this.markstockList.length > 0;
        this.showSubseries = this.checkFeature('conf_useCheeseMarkSubseries');
        this.programma = this.theBakDrain.Persprogram;
        this.kaasmerk = this.theBakDrain.bakKaasMerk;
        this.currentItem = this.theBakDrain.bakKaasMerk;
        this.aantalKazenBasis = this.kaasmerk.kazen;
        if (this.theBakDrain.bakKaasMerk.suggestion) {
            this.theBakDrain.bakKaasMerk = await this.loadKaasMerkVoorstel(
                this.theBakDrain.bakKaasMerk
            );
            this.currentItem = this.theBakDrain.bakKaasMerk;
        } else {
            if (!this.showSubseries) {
                this.showSubseries =
                    this.theBakDrain.bakKaasMerk.beginStockItemID != undefined
                        ? this.theBakDrain.bakKaasMerk.subSeries.length > 0
                        : false;
            }
        }
        // ervoor zorgen dat bij opnieuw opslaan wel de subseries ook worden opgeslagen, vandaar emit in created
        this.$emit('saveSubseries', this.showSubseries);
    }
};
</script>
<style scoped>
/*  
  CSS 
  Remember to use a # before the name because it's an id you're trying to reach
*/
#myButton {
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
}
</style>

